class Doctor {
  private container: HTMLElement | null
  private problems: string[] = []

  constructor(container: string) {
    this.container = document.querySelector(container)
    this.updateHealth = this.updateHealth.bind(this)
    this.updateHealth()
  }

  addProblem(problem: string) {
    this.problems.push(problem)
    return this.updateHealth()
  }

  healthy() {
    return this.problems.length === 0
  }

  clearProblems() {
    return (this.problems = [])
  }

  updateHealth() {
    let status: string
    let text: string
    if (!this.container) {
      return
    }
    setTimeout(this.updateHealth, 3000)

    const health = document.querySelector<HTMLElement>('.js-viewer-health')

    if (!health) {
      return
    }

    if (!this.problems.length) {
      text = 'Everything running smoothly!'
      status = 'is-viewer-good'
    } else {
      text = this.problems.join(', ')
      status = 'is-viewer-bad'
      health.style.display = 'block'
    }

    health.classList.remove('is-viewer-good', 'is-viewer-bad')
    health.classList.add(status)

    const messageEl = health.querySelector('.js-message')

    if (messageEl) {
      messageEl.textContent = text
    }
  }
}

export default Doctor
